import { FormControl, Text } from 'bold-ui'
import { EquipeSelectField, EquipeSelectFieldProps, EquipeSelectModel } from 'components/form'
import { resolveName } from 'components/form/final-form/hooks/useField'
import { Field } from 'react-final-form'

type EquipeResponsavelFieldProps = DistributiveOmit<EquipeSelectFieldProps, 'onChange'> & {
  equipe: EquipeSelectModel
  hasAccessToTodasEquipes: boolean
  onChange?(equipe: EquipeSelectModel): void
}

export function EquipeResponsavelField(props: EquipeResponsavelFieldProps) {
  const { name, equipe, hasAccessToTodasEquipes, required, onChange, ...rest } = props

  const renderField = () => <Text>{equipe ? `${equipe.nome.titleCase()} | ${equipe.ine}` : 'Sem equipe'}</Text>

  return (
    <FormControl label='Equipe responsável' required={required}>
      {hasAccessToTodasEquipes ? (
        <EquipeSelectField name={resolveName(name)} onChange={onChange} required={required} {...rest} />
      ) : (
        <Field<EquipeSelectModel> name={resolveName(name)} initialValue={equipe} render={renderField} />
      )}
    </FormControl>
  )
}
